import { type ReactNode, useEffect } from 'react';
import { PlatformLimitNote } from '@/components/suite/PlatformLimitNote';
import { isLiveMode } from '@/data/live';
import { BrandMark } from '../shell/BrandMark';
import { useRemoveSplash } from '../suite/splash';
import styles from './AuthLayout.module.css';
import { authCopy } from './copy';

/**
 * Moldura das telas de acesso (SPEC-v2 2.2), inspirada na janela de login do macOS: fundo agrupado
 * com material espesso, símbolo da Rota em squircle de 64 px, título e o cartão de 400 px (100% −
 * 32 px no iPhone). Rodapé fixo com o aviso da demonstração.
 */
export function AuthLayout({
  title,
  subtitle,
  page,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  /** Título da aba do navegador. */
  page: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  useRemoveSplash();
  useEffect(() => {
    document.title = authCopy.documentTitle(page);
  }, [page]);
  return (
    <div className={styles.screen}>
      <div className={styles.backdrop} aria-hidden="true" />
      <main className={styles.main} id="conteudo" tabIndex={-1}>
        <div className={styles.column}>
          <div className={styles.mark}>
            <BrandMark size={64} />
          </div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          <div className={styles.card}>{children}</div>
          {footer}
        </div>
      </main>
      {/* Modo ao vivo: o login é do servidor (cookie seguro); o aviso da demonstração não vale. */}
      {!isLiveMode() && (
        <footer className={styles.footer}>
          <PlatformLimitNote id="auth_demo" text={authCopy.demoNote} tone="info" />
        </footer>
      )}
    </div>
  );
}
